import { render } from "./BioDiversity.vue?vue&type=template&id=7530e55e&scoped=true"
import script from "./BioDiversity.vue?vue&type=script&lang=js"
export * from "./BioDiversity.vue?vue&type=script&lang=js"

import "./BioDiversity.vue?vue&type=style&index=0&id=7530e55e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7530e55e"]])

export default __exports__